import { IPreferences } from "@/androidPlugins/IPreferences"

type SparseModePreferences = Record<string, boolean>
const sparseModePreferencesKey = "sparseModePreferences"

const { cashierId } = useAuth()
const getCurrentCashierIdentifier = () =>
  cashierId.value ?? "default"

const sparseModePreferences = ref<
  SparseModePreferences | undefined
>()

const hydrateSparseModePreferences = async () => {
  const { value: rawPreferences } = await IPreferences.get({
    key: sparseModePreferencesKey,
  })

  sparseModePreferences.value =
    rawPreferences === null
      ? {}
      : JSON.parse(rawPreferences)
}

const sparseModeEnabled = computed({
  get: () =>
    sparseModePreferences.value?.[
      getCurrentCashierIdentifier()
    ] ?? false,
  set: async (value: boolean) => {
    if (!sparseModePreferences.value) {
      await hydrateSparseModePreferences()
    }

    if (!sparseModePreferences.value) return

    sparseModePreferences.value[
      getCurrentCashierIdentifier()
    ] = value

    await IPreferences.set({
      key: sparseModePreferencesKey,
      value: JSON.stringify(sparseModePreferences.value),
    })
  },
})

export const useSparseMode = () => {
  if (!sparseModePreferences.value) {
    hydrateSparseModePreferences()
  }

  return { sparseModeEnabled }
}
